import React from 'react';
import {
  useSelector,
} from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  useField,
} from 'formik';

import * as selectors from 'hellospa/page/prep-and-send/data/selectors';
import * as types from 'hellospa/page/prep-and-send/data/types';
import styles from './index.scss';
import messages from './intl';

import Toggle from '../../toggle/index';
import { ArrowDirection, TooltipPoint } from '../../../foundation/control/tooltip';

const RecipientReassignment = () => {
  const intl = useIntl();
  const isSendingTemplate = useSelector(selectors.isSendingTemplate);
  const allowRecipientReassignment = useSelector(selectors.allowRecipientReassignment);
  const [recipientReassignmentField, , recipientReassignmentToggle] = useField<boolean>('recipientReassignment');
  const [recipientField] = useField<types.Recipient[]>('recipients');
  const [qesField] = useField<boolean>('qes');
  let disabled = isSendingTemplate;

  const hasSmsAuthNumber = React.useMemo(() => {
    return recipientField.value.some((r) => 'smsAuthNumber' in r && r.smsAuthNumber !== '');
  }, [recipientField]);

  if (qesField.value) {
    disabled = true;
  }

  if (!allowRecipientReassignment || hasSmsAuthNumber) {
    return null;
  }

  return (
    <div className={styles.signerOptionsContainer}>
      <label className={styles.ssToggleLabel} >
        <div>
          {
            disabled
            && <TooltipPoint className={styles.tooltipDown} arrow={ArrowDirection.Bottom}>
              <FormattedMessage id=''
                description='Disabled Recipient Reassignment message'
                defaultMessage='Unable to reassign when Qualified eSignature is selected' />
            </TooltipPoint>
          }
          <Toggle
            id="recipients-fields-reassignment"
            indeterminate={false}
            disabled={disabled}
            className={styles.ssToggle}
            {...recipientReassignmentField}
            onChange={(e) => {
              recipientReassignmentToggle.setValue(!recipientReassignmentField.value);
              return recipientReassignmentField.onChange(e);
            }}
            value=""
            checked={recipientReassignmentField.value}
            data-qa-ref="recipients.fields.reassignment" />
        </div>
        <div className={styles.ssLabelText}>
          {intl.formatMessage(messages.enableReassignmentCheckbox)}
        </div>
      </label>
    </div>
  );
};

export default RecipientReassignment;
